import gql from 'graphql-tag';

const GET_BETA_ACCESS = gql`
  query GetBetaAccess($student_book_id: Int, $route_name: String) {
    getBetaAccess(student_book_id: $student_book_id, route_name: $route_name) {
      enable_beta,
      role_code,
      inherited_beta_level
    }
  }
`;

export { GET_BETA_ACCESS };
